const timestamp = (value) => value == null ? NaN : new Date(value).getTime();
const hasContract = (row) => Object.hasOwn(row, 'observed_at') || Object.hasOwn(row, 'expires_at');

// Source observation deadlines survive cache reads. Receipt time is never a
// freshness input. Rows from the legacy response remain unchanged during rollout.
export function expireDeparturePrediction(row, nowMs) {
  if (!row || !hasContract(row)) return row;
  const observed = timestamp(row.observed_at);
  const expires = timestamp(row.expires_at);
  if (Number.isFinite(nowMs) && observed <= nowMs && expires > nowMs && expires > observed) return row;
  return {
    ...row,
    expected_departure_time: null,
    estimated_departure_time: null,
    destination_stop_expected_arrival_time: null,
    live: false,
    // Alert-derived cancellations have an independent lifetime. Only remove
    // statuses explicitly attributed to this expiring prediction.
    ...(row.cancellation_source === 'prediction' ? { cancelled: false } : {}),
    ...(row.skip_source === 'prediction' ? { skipped: false } : {}),
  };
}

export function applyDepartureBoardFreshness(rows, nowMs) {
  if (!Array.isArray(rows)) return rows;
  const result = rows.map(row => expireDeparturePrediction(row, nowMs));
  if (result.every((row, index) => row === rows[index])) return rows;
  // Keep server-filtered membership. Expiry can change the effective ordering,
  // including a delayed call falling behind another after scheduled fallback.
  return result.sort((left, right) => {
    const a = timestamp(left.expected_departure_time || left.scheduled_departure_time);
    const b = timestamp(right.expected_departure_time || right.scheduled_departure_time);
    return Number.isFinite(a) && Number.isFinite(b) ? a - b : 0;
  });
}

export function nextDeparturePredictionExpiry(rows, nowMs) {
  if (!Array.isArray(rows)) return null;
  let next = Infinity;
  for (const row of rows) {
    const expiry = timestamp(row?.expires_at);
    if (expiry > nowMs && expiry < next) next = expiry;
  }
  return Number.isFinite(next) ? next : null;
}
